import { Pipe, PipeTransform } from '@angular/core';
import { FuncMinutes2Format, MinutesOutputFormat } from './funcMinutes2HourFormat';

@Pipe({
    name: 'formatMinutes'
})
export class FormatMinutesPipe implements PipeTransform {

    transform(value: number, pattern: MinutesOutputFormat) : string {
        try {
            return FuncMinutes2Format.RenderMinutes(value, pattern);
        } catch {
            return '';
        }
    }
}
